import { Resource } from 'Workspace/ResourceProvider/resourceTypes';

export interface CompReferences {
	r1: string;
	r2: string;
}

export interface DirectoryContext {
	identityProvider: string;
	forest: string;
	domain: string;
	tenantId: string;
}

export interface Identity {
	oid: string;
	sid: string;
	upn: string;
	email: string;
	customers: unknown[];
}

export interface UserIdentity {
	identity: Identity;
	groups: {
		sid: string;
	}[];
	directoryContext: DirectoryContext;
}

export interface Manifest {
	leaseId: string;
	leaseType: LeaseFileType;
	leaseTypeKey: string;
	workspaceUrl: string;
	customerId: string;
	fileName: string;
	fromTemplate: string;
	leaseVersion?: string;
	resourceKey?: string;
	resourceName?: string;
	validFrom?: string;
	validTo?: string;
	endpointDeviceId?: string;
	endpointDevicePublicKeyThumbprint?: string;
	endpointClientType?: string;
	endpointClientName?: string;
	userIdentity?: UserIdentity;
	endpointDeviceAppProtectionCapable?: boolean;
}

export interface LeaseDocument {
	payload: string;
	manifest: Manifest;
	compReferences?: CompReferences;
}

export interface ConnectionLeaseKey {
	encryptedForEntity: string;
	alg: string;
	kid: string;
	key: string;
}

export interface Signature {
	dateSigned: string;
	signingEntity: string;
	alg: string;
	kid: string;
	signature: string;
}

export enum LeaseFileType {
	XD_Resource_Comp_ResLocs = 'XD_Resource_Comp_ResLocs',
	XD_Resource_Comp_Param = 'XD_Resource_Comp_Param',
	XD_Resource = 'XD_Resource',
}

export interface LeaseFile {
	document: LeaseDocument;
	connectionLeaseKeys: ConnectionLeaseKey[];
	signatures: Signature[];
}

export interface Policy {
	frequency: {
		minimumInMinutes: number;
	};
}

export enum ServiceName {
	LeasingService = 'leasingservice',
	CitrixDaaS = 'leasingsyncservice',
}

export interface Properties {
	alwaysBypassAuthForCachedResources: boolean;
	bypassAuthForCachedResources: boolean;
	resourceLeasingEnabled: boolean;
	deleteResourceLeasesOnLogOff: boolean;
	resourceLeaseValidityPeriodInDays: number;
	telemetryHeadlessLaunchEnabled: boolean;
	telemetryLaunchShadowDelayMins: number;
	telemetryLaunchMinTimeIntervalMins: number;
}

export interface LeaseProperties {
	policies: {
		policy: Policy;
		serviceName: ServiceName;
	}[];
	properties: Properties;
}

export interface ShieldInformation {
	lastCLSyncStatus: CLSyncStatus;
	lastLeaseSyncSuccessTime: string;
	leaseFiles: string[];
	leaseProperties: LeaseProperties;
}

export enum CLSyncStatus {
	Succeeded = 'Succeeded',
	Failed = 'Failed',
	NotAvailable = 'Not available',
}

export interface ShieldStatus {
	lastCLSyncStatus: CLSyncStatus;
	lastLeaseSyncSuccessTime: string;
	expiredLeases: Resource[];
	expiringLeases: Resource[];
	activeLeases: Resource[];
}
